import config from "config/config";

export const BG_IMAGE_BASIC_URL = `url(${config.staticUrl}/i/check-your-compensation.jpg)`;
export const BG_IMAGE_AHP_MOBILE_URL = `url(${config.staticUrl}/i/airhelp-plus/cta-airhelp-plus-bg-mobile.png)`;
export const BG_IMAGE_AHP_DESKTOP_URL = `url(${config.staticUrl}/i/airhelp-plus/cta-airhelp-plus-bg-desktop.png)`;
